import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FaDuotoneIconComponent, FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CodeEditorModule } from '@ngstack/code-editor';
import { HighlightModule } from 'ngx-highlightjs';
import { MatomoRouterModule } from 'ngx-matomo-client';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { FormatBytePipe } from '@bn/shared/entities/pipes';
import { ServiceInjectorModule } from '@bn/shared/entities/service-injectors';
import { FontawesomeGradientDirective, LazyLoadDirective, MarkAllTouchedDirective } from '@bn/web-ui';
import { AlertComponent } from '@bn/web-ui/alert/alert.component';
import { BnToastrComponent } from '@bn/web-ui/toastr/components/bn-toastr/bn-toastr.component';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { ButtonDropdownComponent } from '@bn/web-ui/button-dropdown/button-dropdown.component';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { ContentComponent } from '@bn/web-ui/content/content.component';
import { DatePickerComponent } from '@bn/web-ui/datepicker/datepicker.component';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { EntityOverviewComponent } from '@bn/web-ui/entity-overview/entity-overview.component';
import { LearnMoreButtonComponent } from '@bn/web-ui/index';
import { InputComponent } from '@bn/web-ui/input/input.component';
import { BnLeafletMapComponent } from '@bn/web-ui/leaflet-map/leaflet-map.component';
import { LoadingComponent } from '@bn/web-ui/loading/loading.component';
import { BnNotificationItemComponent } from '@bn/web-ui/notification-item/notification-item.component';
import { ListWithIconComponent } from '@bn/web-ui/premium-banner/list-with-icon/list-with-icon.component';
import { PricingCardComponent } from '@bn/web-ui/pricing-card/pricing-card.component';
import { SelectComponent } from '@bn/web-ui/select/select.component';
import { SelectInputListComponent } from '@bn/web-ui/select-input-list/select-input-list.component';
import { StatCardComponent } from '@bn/web-ui/stat-card/stat-card.component';
import { StepCardComponent } from '@bn/web-ui/step-card/step-card.component';
import { StepsComponent } from '@bn/web-ui/steps-component/steps.component';
import { SwitchComponent } from '@bn/web-ui/switch/switch.component';
import { RadioTabsComponent } from '@bn/web-ui/tabs/radio-tabs.component';
import { TabsComponent } from '@bn/web-ui/tabs/tabs.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { DashboardCoreModule } from './core/src';
import { LayoutModule } from './layout/layout.module';
import {
  ExpiredTrialModalComponent,
  ExtendTrialAllUsersModalComponent,
  ExtendTrialModalComponent,
  PermissionsUpdateModalComponent,
  UserDisabledModalComponent,
} from './modals';
import { DemoComponentsPage } from './pages/components/demo-components.page';
import { LogoutPage } from './pages/logout/logout.page';
import { MultiplePortsComponent } from './pages/magic-containers/components/add-edge-endpoints/multiple-ports/multiple-ports.component';
import { AdvancedSettingsComponent } from './pages/magic-containers/components/advanced-settings';
import { DashboardSharedModule } from './shared/src';

@NgModule({
  declarations: [
    AppComponent,
    DemoComponentsPage,
    PermissionsUpdateModalComponent,
    ExtendTrialAllUsersModalComponent,
    ExtendTrialModalComponent,
    ExpiredTrialModalComponent,
    UserDisabledModalComponent,
    LogoutPage,
  ],
  imports: [
    CodeEditorModule.forRoot({
      baseUrl: 'https://panel-production-libs.b-cdn.net/monaco/0.48.0/min/',
      editorVersion: 'vs',
      typingsWorkerUrl: 'assets/workers/typings-worker.js',
    }),
    AppRoutingModule,
    BrowserModule,
    DashboardCoreModule,
    DashboardSharedModule,
    LayoutModule,
    ServiceInjectorModule,
    FormsModule,
    ReactiveFormsModule,
    FaIconComponent,
    FaDuotoneIconComponent,
    NgxSkeletonLoaderComponent,
    FormatBytePipe,
    FontawesomeGradientDirective,
    LazyLoadDirective,
    MarkAllTouchedDirective,
    AlertComponent,
    BnLeafletMapComponent,
    BnNotificationItemComponent,
    BnToastrComponent,
    ButtonComponent,
    ButtonDropdownComponent,
    CardComponent,
    ContentComponent,
    DatePickerComponent,
    DropdownMenuComponent,
    EntityOverviewComponent,
    InputComponent,
    ListWithIconComponent,
    LoadingComponent,
    PricingCardComponent,
    RadioTabsComponent,
    SelectComponent,
    SelectInputListComponent,
    StatCardComponent,
    StepCardComponent,
    StepsComponent,
    SwitchComponent,
    TabsComponent,
    MatomoRouterModule,
    AdvancedSettingsComponent,
    MultiplePortsComponent,
    HighlightModule,
    LearnMoreButtonComponent,
  ],
  providers: [appConfig],
  bootstrap: [AppComponent],
})
export class AppModule {}
